import React, { useState, useEffect } from 'react';
import styles from './CopyButton.module.css';
import { CopyIcon, CheckIcon } from './Icons'; // Import from common Icons directory

interface CopyButtonProps {
  textToCopy: string;
  onCopy?: (success: boolean, error?: Error) => void;
  className?: string;
  title?: string; // For accessibility and tooltip
}

// Removed local SVG definitions for CopyIcon and CheckIcon

const CopyButton: React.FC<CopyButtonProps> = ({
  textToCopy,
  onCopy,
  className = '',
  title = 'Copiază în clipboard',
}) => {
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    let timeoutId: number;
    if (isCopied) {
      timeoutId = window.setTimeout(() => {
        setIsCopied(false);
      }, 2000); // Reset after 2 seconds
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [isCopied]);

  const handleCopy = async () => {
    if (!navigator.clipboard) {
      // Clipboard API not available (e.g., insecure context)
      if (onCopy) onCopy(false, new Error('Clipboard API not available.'));
      // Optionally, implement a fallback mechanism here (e.g., for older browsers)
      console.error('Clipboard API not available.');
      return;
    }

    try {
      await navigator.clipboard.writeText(textToCopy);
      setIsCopied(true);
      if (onCopy) onCopy(true);
    } catch (err) {
      setIsCopied(false);
      if (onCopy) onCopy(false, err as Error);
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <button
      type="button"
      className={`${styles.copyButton} ${isCopied ? styles.copied : ''} ${className}`.trim()} // Added .trim() for safety
      onClick={handleCopy}
      title={isCopied ? 'Copiat!' : title}
      aria-label={isCopied ? 'Copiat în clipboard' : title}
      disabled={isCopied} // Optionally disable briefly after copy
    >
      {isCopied ? 
        <CheckIcon className={styles.icon} title="Copiat cu succes" /> : 
        <CopyIcon className={styles.icon} title="Copiază conținut" />
      }
    </button>
  );
};

export default CopyButton; 